export const can = (user, module, action = "view") =>
  !!user && (user.role === "admin" || !!user.permissions?.[module]?.[action]);

export const MODULE_PATHS = [
  { module: "dashboard", path: "/" },
  { module: "ordens", path: "/ordens" },
  { module: "produtos", path: "/produtos" },
  { module: "clientes", path: "/clientes" },
  { module: "estoque", path: "/estoque" },
  { module: "expedicao", path: "/expedicao" },
  { module: "engenharia", path: "/engenharia" },
  { module: "relatorios", path: "/relatorios" },
  { module: "manual", path: "/manual" },
  { module: "auditoria", path: "/auditoria" },
  { module: "usuarios", path: "/usuarios" },
  { module: "configuracoes", path: "/configuracoes" },
];

export const firstAllowedPath = (user) =>
  (MODULE_PATHS.find((m) => can(user, m.module)) || { path: "/manual" }).path;
